import { resolveEditorComponent } from '../../../resolveEditorComponent';

export type BorderRadiusPreviewProps = {
  value: string | null;
  isMixed?: boolean;
  emptyPreviewLabel: string;
};

export default resolveEditorComponent({
  default: () => import('./variants/DefaultBorderRadiusPreview'),
  overrides: {},
});
